import React from 'react'

export interface FieldErrorProps {
  children: React.ReactNode
}

export const FieldError: React.FC<FieldErrorProps> = React.memo(({ children }) => (
  <div className="text-error mt-2">{children}</div>
))
